import { useQuery } from "@tanstack/react-query";
import type { SellerCustomerDetailView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseSellerCustomerQueryParams = {
  storeSlug: string;
  customerId: string | null;
};

export function useSellerCustomerQuery(params: UseSellerCustomerQueryParams) {
  const { storeSlug, customerId } = params;
  const query = useQuery({
    queryKey: queryKeys.seller.customerDetail(storeSlug, customerId ?? ""),
    queryFn: () =>
      apiJsonClient<SellerCustomerDetailView>(
        endpoints.seller.customerById(customerId ?? ""),
      ),
    enabled: storeSlug.length > 0 && Boolean(customerId),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
